import { render, staticRenderFns } from "./OfferListItem.vue?vue&type=template&id=66c0c2ce&scoped=true"
import script from "./OfferListItem.vue?vue&type=script&lang=js"
export * from "./OfferListItem.vue?vue&type=script&lang=js"
import style0 from "./OfferListItem.vue?vue&type=style&index=0&id=66c0c2ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c0c2ce",
  null
  
)

export default component.exports